export default "\n<app-full-layout></app-full-layout>"